<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content ? `${content} | m2VET` : `m2VET` }}</template>
  </metainfo>
  <AlertVue/>
  <SuccessAlert/>
  <NavigationVue @toggleBlur="toggleBlur"/>
  <div
      class="wrapper"
      ref="wrapper"
      :class="{
      'wrapper--with-sidebar': showSidebar,
      'wrapper--home': isHomeRoute && !showSidebar
    }"
  >
    <router-view/>
  </div>
  <div
      class="footer-wrapper"
      :class="{
      'footer-wrapper--with-sidebar': showSidebar,
      'footer-wrapper--home': isHomeRoute && !showSidebar
    }"
  >
    <Footer v-if="!showSidebar" />
  </div>

  <div v-if="showEntryModal" class="entry-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="entry-modal-title">
    <div class="entry-modal">
      <h2 id="entry-modal-title" class="entry-modal__title">Wybierz, jak chcesz korzystać z serwisu</h2>
      <p class="entry-modal__text">Aby przejść dalej, wybierz jedną z opcji:</p>
      <div class="entry-modal__actions">
        <button type="button" class="entry-modal__btn" @click="selectEntryMode('do specjalistów')">Jestem specjalistą</button>
        <button type="button" class="entry-modal__btn entry-modal__btn--secondary" @click="selectEntryMode('do właścicieli zwierząt')">Szukam usług</button>
      </div>
    </div>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import { useAuthStore } from './stores/auth';
import { useAppStore } from './stores/app';
import NavigationVue from './components/Navigation.vue';
import AlertVue from './components/AlertVue.vue';
import Footer from './components/Footer.vue';
import SuccessAlert from './components/SuccessAlert.vue';

export default {
  name: 'App',
  setup () {
    useMeta({
      title: '',
      htmlAttrs: { lang: 'pl' },
      description: 'Portal dla twojego pupila',
      meta: [{ name: 'robots', Name: 'robots', content: 'none' }]
    })
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    }
  },
  components: {
    NavigationVue,
    AlertVue,
    Footer,
    SuccessAlert
  },
  data() {
    return {
      showEntryModal: false
    };
  },
  computed: {
    isPublicRoute() {
      const path = this.$route.path;
      const publicExact = [
        '/404', '/dla-biznesu', '/', '/login', '/login/reset', '/login/reset2',
        '/register', '/blog', '/announcements', '/browser', '/statute',
        '/cookies', '/privacy', '/report', '/spec-browser', '/register2',
        '/confirm-newsletter', '/advance-payment/result', '/profile/make-appointment', '/kontakt'
      ];
      return publicExact.includes(path) || path.indexOf('/blog/entry/') === 0 || path.indexOf('/browse/user/') === 0;
    },
    showSidebar() {
      return this.authStore.loggedIn && !this.isPublicRoute;
    },
    isHomeRoute() {
      return this.$route.path === '/';
    }
  },
  mounted(){
    if(!this.authStore.user){
      localStorage.removeItem('userm2VET')
    }else{
      this.appStore.setIsSubscribed(this.authStore.user);
    }

    const savedEntryMode = localStorage.getItem('m2vetEntryMode');
    this.showEntryModal = !savedEntryMode;
    document.body.style.overflow = this.showEntryModal ? 'hidden' : '';
  },
  methods:{
    toggleBlur(){
      this.$refs.wrapper.classList.add('active-blur')
      setTimeout(() => {
        this.$refs.wrapper.classList.remove('active-blur')
      }, 1000)
    },
    selectEntryMode(mode) {
      localStorage.setItem('m2vetEntryMode', mode);
      this.showEntryModal = false;
      document.body.style.overflow = '';
    }
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  }
}
</script>

<style lang="scss">
@use '../node_modules/normalize.css/normalize.css';

@font-face {
  font-family: 'Roboto';
  src: url("./font/Roboto/Roboto-Regular.ttf") format("truetype");
  src: url("./font/Roboto/Roboto-Bold.ttf") format("truetype");
  src: url("./font/Roboto/Roboto-Light.ttf") format("truetype");
}

#app {
  font-family: 'Roboto',sans-serif;
  color: #000000;
  font-size: 2rem;
}

html{
  font-size: 62.5%;
}

.position-relative {
  position: relative;
}

.wrapper{
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px 0 20px;
  min-height: calc(100vh - 200px);
  z-index: 0;
}
.wrapper--home{
  max-width: none;
  padding: 0;
}
.wrapper--with-sidebar{
  max-width: none;
  margin-left: 300px;
  padding: 100px 30px 0 30px;
}
.active-blur{
  animation-name: blur;
  animation-duration: .5s;
}
.footer-wrapper{
  background-color: #F2F2F2;
  margin-top: 50px;
}
.footer-wrapper--home{
  background-color: transparent;
  margin-top: 0;
}
.footer-wrapper--with-sidebar{
  margin-left: 300px;
}

.entry-modal-overlay{
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}
.entry-modal{
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 12px;
  padding: 28px 24px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}
.entry-modal__title{
  margin: 0 0 8px 0;
  font-size: 2.4rem;
  line-height: 1.2;
}
.entry-modal__text{
  margin: 0 0 20px 0;
  font-size: 1.6rem;
}
.entry-modal__actions{
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.entry-modal__btn{
  border: 0;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: 600;
  color: #fff;
  background: #f97316;
}
.entry-modal__btn--secondary{
  background: #176b4d;
}
.mt-3 {
  margin-top: 2rem;
}

@media (max-width: 1100px){
  .wrapper--with-sidebar{
    margin-left: 0;
    padding: 100px 20px 0 20px;
  }

  .footer-wrapper--with-sidebar{
    margin-left: 0;
  }
}

@keyframes blur {
  0%{
    opacity: 1;
  }
  50%{
    opacity: 0.1;
  }
  100%{
    opacity: 1;
  }
}
</style>